import CallRequestsContainer from './call-requests-container';

export default CallRequestsContainer;
